import {throttle} from 'throttle-debounce';

class Header {
    constructor() {
        this.body = document.querySelector('body');
        const stickyElm = document.querySelector('.page-header');
        
        if (stickyElm) {
            const observer = new IntersectionObserver(
                ([e]) => this.body.classList.toggle('scrolled', e.intersectionRatio < 1),
                {threshold: [1]}
            );
            observer.observe(stickyElm);
        }
    }
}

export default Header;